import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as Projects from 'projects/components';
import ProjectsListHandlers from 'projects/containers/ProjectsListHandlers';
import ProjectsRowContainer from 'projects/containers/ProjectsRowContainer';

import { getCompany, getSubcompany, getPermissions } from 'auth/selectors';
import {
  getPagination,
  getFilters,
  getVisibleProjects,
  getIsLoading,
  getNeedFetch,
} from 'projects/selectors';
import { toggleProject } from 'projects/actions';
import { addGrowlError as error, addGrowlSuccess as success } from 'messages/actions';

class ProjectsListContainer extends PureComponent {
  static propTypes = {
    company: PropTypes.object.isRequired,
    subcompany: PropTypes.object.isRequired,
    pagination: PropTypes.object.isRequired,
    filters: PropTypes.object.isRequired,
    permissions: PropTypes.object.isRequired,
  };
  handleToggle = (id) =>
    this.props
      .toggleProject(id, this.props.company.id, this.props.subcompany.id)
      .then(({ value }) => this.props.success(value.message))
      .catch((err) => this.props.error(err.message));

  render = () => (
    <ProjectsListHandlers
      render={({
        handleOrderChange,
        handleLimitChange,
        handlePageChange,
        handleFiltersChange,
        handleSubmit,
        columnSearch, // Cambiar por redux
        handleToggleSearch, // Agregar
      }) => (
        <Projects.ListView
          count={this.props.projects.length}
          filters={this.props.filters}
          company={this.props.company}
          isLoading={this.props.isLoading}
          handleToggle={this.handleToggle}
          handleOrderChange={handleOrderChange}
          handleSubmit={handleSubmit}
          handleFiltersChange={handleFiltersChange}
          handleLimitChange={handleLimitChange}
          handlePageChange={handlePageChange}
          handleToggleSearch={handleToggleSearch} // Agregar
          columnSearch={columnSearch} // Agregar - corregir por Redux
          subcompany={this.props.subcompany}
          pagination={this.props.pagination}
          permissions={this.props.permissions}
        >
          {this.props.projects.map((project) => (
            <ProjectsRowContainer
              key={project.id}
              project={project}
              handleToggle={this.handleToggle}
            />
          ))}
        </Projects.ListView>
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  subcompany: getSubcompany(state),
  pagination: getPagination(state),
  filters: getFilters(state),
  projects: getVisibleProjects(state),
  permissions: getPermissions(state),
  isLoading: getIsLoading(state),
  needFetch: getNeedFetch(state),
});
const mapDispatchToProps = { toggleProject, error, success };

export default connect(mapStateToProps, mapDispatchToProps)(ProjectsListContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/projects/containers/ProjectsListContainer.js